<template>
  <el-dialog
    width="80%"
    v-model="visible"
    top="5vh"
    :class="'history-modal'"
    :before-close="handleClose"
  >
    <template #header>
      <div class="text-box">
        <span class="h-l"></span>
        <span class="header-text">{{ title }}</span>
        <span class="h-r"></span>
      </div>
    </template>
    <div class="history">
      <div class="history-con">
        <el-table :data="tableData" height="5rem">
          <el-table-column prop="id" label="序号" width="100%">
          </el-table-column>
          <el-table-column
            prop="dateTime"
            label="日期"
            :formatter="formatterTime"
          ></el-table-column>
          <el-table-column prop="className" width="100px" label="班次">
          </el-table-column>
          <el-table-column prop="status" width="150px" label="最终结果">
            <template #default="scope">
              <span :class="'text_' + scope.row.status">{{
                statusMap[scope.row.status]
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="mhi" label="MHI" width="100">
          </el-table-column>

          <el-table-column label="操作" width="180%">
            <template #default="scope">
              <div class="detail-btn" @click="look(scope.$index, scope.row)">
                监测历史
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          v-if="pageRes.total > 10"
          background
          layout="prev, pager, next"
          :total="pageRes.total"
          class="page"
          v-model:currentPage="page.pageNum"
          @current-change="handleCurrentChange"
          :page-size="page.pageSize"
        >
        </el-pagination>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import moment from "moment";
export default {
  name: "HistoryModal",
  props: {
    visible: Boolean,
    id: String,
  },
  data() {
    return {
      tableData: [],
      page: {
        pageNum: 1,
        pageSize: 10,
      },
      pageRes: {
        total: 200,
      },
      statusMap: {
        0: "未运行",
        1: "数据正常",
        2: "数据异常",
        3: "通信异常",
      },
    };
  },
  computed: {
    title() {
      return `${this.$route.query.diskId}#转盘第${this.$route.query.seatId}位-全部班次`;
    },
  },
  watch: {
    visible: async function (nV, oV) {
      if (nV) {
        console.log("打开弹窗-班次历史");
        await this.getList();
      } else {
        console.log("关闭弹窗-班次历史");
      }
    },
  },
  methods: {
    async getList() {
      try {
        let res = await this.$myRequest({
          url: "/getSeatHistoryListReq",
          method: "post",
          data: {
            diskId: this.$route.query.diskId, //转盘id
            seatId: this.$route.query.seatId, //位置id
            page: this.page,
          },
        });
        res = res.data;
        this.pageRes = res.data.page;
        this.tableData = res.data.list;
      } catch (err) {
        console.log(err);
      }
    },
    handleClose() {
      this.$emit("update:visible", false);
    },
    look(index, row) {
      this.handleClose();
      this.$router.push({
        name: "Shit",
        query: {
          diskId: this.$route.query.diskId,
          seatId: this.$route.query.seatId,
          testStatId: row.id,
          historyId: this.$route.query.historyId
            ? this.$route.query.historyId
            : 0,
        },
      });
    },
    formatterMode(row, column) {
      let option = { 0: "手动", 1: "自动" };

      return option[row.mode];
    },
    formatterTarget(row, column) {
      if (row.mode == 0) {
        return `${row.diskId}号转盘${row.seatId}号位置`;
      } else {
        return "全部";
      }
    },
    formatterTime(row, column) {
      return moment(row.dateTime).format("YYYY.MM.DD HH:mm:ss");
    },
    handleCurrentChange() {
      this.getList();
    },
  },
  mounted() {},
};
</script>
<style scoped lang="less" src="./index.less"></style>
